import request from '@/utils/request'

// 查询
export function fetchList (data) {
  return request.post('/customer/project/page', data, {
    trim: true
  })
}

// 收款
export function collect (projectId) {
  return request.post(`/customer/project/collect/${projectId}`)
}

// 领取案例
export function receive (projectId) {
  return request.post(`/customer/project/receive/${projectId}`)
}

// 交付
export function delivery (data) {
  return request.post('/customer/project/delivery', data)
}

// 批量收款
export function collectInBatch (ids) {
  return request.get('/customer/project/collectInBatch', {
    params: {
      ids
    }
  })
}
